'use strict';

var index = require('./ErrorBoundary/index.cjs');
var utils = require('./utils.cjs');
var index$1 = require('./ServerSideSuspense/index.cjs');
var index$2 = require('./Show/index.cjs');
var index$3 = require('./SwitchCase/index.cjs');
var createScopedContext = require('./context/createScopedContext.cjs');
var CodeBaseFeatureFlagsProvider = require('./context/codeBaseFeatureFlags/CodeBaseFeatureFlagsProvider.cjs');
var codeBaseFeatureDefinitions = require('./context/codeBaseFeatureFlags/codeBaseFeatureDefinitions.cjs');
var userAgentFromServer = require('./context/userAgentFromServer.cjs');
var index$4 = require('./forwardRefWithHook/index.cjs');
var createGlobalReferenceContext = require('./createGlobalReferenceContext.cjs');



exports.ErrorBoundary = index;
exports.handleCustomError = utils.handleCustomError;
exports.ServerSideSuspense = index$1;
exports.Show = index$2;
exports.SwitchCase = index$3;
exports.createScopedContext = createScopedContext;
exports.CodeBaseFeatureFlagsProvider = CodeBaseFeatureFlagsProvider;
exports.getCodeBaseFeatureFlag = codeBaseFeatureDefinitions.getCodeBaseFeatureFlag;
exports.UserAgentFromServerContextProvider = userAgentFromServer.UserAgentFromServerContextProvider;
exports.useUserAgentFromServer = userAgentFromServer.useUserAgentFromServer;
exports.userAgentFromServerContext = userAgentFromServer.userAgentFromServerContext;
exports.forwardRefWithHook = index$4;
exports.createGlobalReferenceContext = createGlobalReferenceContext.createGlobalReferenceContext;
//# sourceMappingURL=index.cjs.map
